const initialState = {
    payrollPermissions: {},
    createRateListData: {},
    deleteRateListData: {},
    allRateListData: [],
    singleRateListData: {},
    updateRateListData: {},
    createFOTdsParticularData: {},
    allFOTdsParticularData: [],
    loadingPayroll: false,
    errorsPayroll: {},
};

const PayrollReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case "GET_ALL_RATE_LIST_PENDING":
    case "ADD_CREATE_RATE_LIST_PENDING":
    case "DELETE_RATE_LIST_PENDING":
    case "GET_SINGLE_RATE_LIST_PENDING":
    case "UPDATE_RATE_LIST_PENDING":
    case "ADD_CREATE_FO_TDS_PARTICULAR_PENDING":
    case "GET_ALL_FO_TDS_PARTICULAR_PENDING":
    case "UPDATE_FO_TDS_PARTICULAR_PENDING":
    case "DELETE_FO_TDS_PARTICULAR_PENDING":
      return { 
        ...state, 
        loadingPayroll: true 
    };

    case "GET_ALL_RATE_LIST_FULFILLED":
      return { 
        ...state, 
        loadingPayroll: false, 
        allRateListData: action.payload, 
        errorsPayroll: {} 
    };

    case "GET_ALL_FO_TDS_PARTICULAR_FULFILLED":
      return { 
        ...state, 
        loadingPayroll: false, 
        allFOTdsParticularData: action.payload?.data || action.payload || [], 
        payrollPermissions: action.payload?.permissions || {},
        errorsPayroll: {} 
    };

    case "ADD_CREATE_RATE_LIST_FULFILLED":
      return { 
        ...state, 
        loadingPayroll: false, 
        createRateListData: action.payload, 
        errorsPayroll: {} 
    };

    case "DELETE_RATE_LIST_FULFILLED":
      return { 
        ...state, 
        loadingPayroll: false, 
        deleteRateListData: action.payload,
        errorsPayroll: {}
      };

    case "GET_SINGLE_RATE_LIST_FULFILLED":
      return { 
        ...state, 
        loadingPayroll: false, 
        singleRateListData: action.payload,
        errorsPayroll: {} 
    };

    case "UPDATE_RATE_LIST_FULFILLED":
      return { 
        ...state, 
        loadingPayroll: false, 
        updateRateListData: action.payload,
        errorsPayroll: {} 
    };
    case "ADD_CREATE_FO_TDS_PARTICULAR_FULFILLED":
      return {
        ...state,
        loadingPayroll: false,
        createFOTdsParticularData: action.payload,
        errorsPayroll: {},
      };

    case "UPDATE_FO_TDS_PARTICULAR_FULFILLED":
      return {
        ...state,
        loadingPayroll: false,
        createFOTdsParticularData: action.payload,
        errorsPayroll: {},
      };

    case "DELETE_FO_TDS_PARTICULAR_FULFILLED":
      return {
        ...state,
        loadingPayroll: false,
        createFOTdsParticularData: action.payload,
        errorsPayroll: {},
      };
    
    case "GET_ALL_RATE_LIST_REJECTED":
    case "ADD_CREATE_RATE_LIST_REJECTED":
    case "DELETE_RATE_LIST_REJECTED":
    case "GET_SINGLE_RATE_LIST_REJECTED":
    case "UPDATE_RATE_LIST_REJECTED":
    case "ADD_CREATE_FO_TDS_PARTICULAR_REJECTED":
    case "GET_ALL_FO_TDS_PARTICULAR_REJECTED":
    case "UPDATE_FO_TDS_PARTICULAR_REJECTED":
    case "DELETE_FO_TDS_PARTICULAR_REJECTED":
      return { 
        ...state, 
        loadingPayroll: false, 
        errorsPayroll: action.payload 
    };
    
    case "RESET_CREATE_RATE_LIST":
      return { 
        ...state, 
        loadingPayroll: false, 
        createRateListData: {} 
    };
    case "RESET_DELETE_RATE_LIST":
      return {
        ...state,
        loadingPayroll: false,
        deleteRateListData: {}
      };
    case "RESET_UPDATE_RATE_LIST":
      return {
        ...state,
        loadingPayroll: false,
        updateRateListData: {}
      };
    case "RESET_CREATE_FO_TDS_PARTICULAR":
      return {
        ...state,
        loadingPayroll: false,
        createFOTdsParticularData: {},
        errorsPayroll: {},
      };
    default:
      return state;
  }
};

export default PayrollReducer;

